
import { MUTATIONS } from '@/store/mutations';
import { GETTERS } from '@/store/getters';
import NavigationFooter from '@/core/components/NavigationFooter.vue';
import BookingTime from '@/core/components/BookingTime.vue';
import { CreateBooking } from '@/models/bookings';
import moment from 'moment';
import { CREATE_BOOKING_DATE_FORMAT } from '@/utils/constants';
import BookingMixin from '../mixins/BookingDateMixin';

export default BookingMixin.extend({
  data() {
    return {
      today: moment().format('YYYY-MM-DD'),
      date: '',
      booking: {} as CreateBooking,
    };
  },

  components: {
    NavigationFooter,
    BookingTime,
  },

  created() {
    this.$store.commit(MUTATIONS.SET_HEADER, { title: this.$t('bookings.headers.start_date'), subtitle: '' });
    this.booking = this.$store.getters[GETTERS.GET_CREATE_BOOKING];
    this.date = moment(this.booking.startDate ?? moment(), CREATE_BOOKING_DATE_FORMAT).format('YYYY-MM-DD');
  },

  methods: {
    async onDateChanged(): Promise<void> {
      const period = moment(this.date).format('YYYY-MM');
      await this.setDatePickerBookingDatesColor(
        period,
        this.booking.startDate ?? '',
        moment(this.date).format(CREATE_BOOKING_DATE_FORMAT),
      );
      await this.setDatePickerColor(period, this.getMonthlyBookings(period));
    },

    onDateSelected(): void {
      this.booking.startDate = moment(this.date, 'YYYY-MM-DD').format(CREATE_BOOKING_DATE_FORMAT);
      this.$store.commit(MUTATIONS.SET_CREATE_BOOKING, this.booking);
      const period = moment(this.date).format('YYYY-MM');
      this.$store.commit(MUTATIONS.SET_MONTHLY_BOOKING, this.getMonthlyBookings(period));
      this.$router.push('/booking/start-time');
    },
  },
});
